var React = require('react');

function Triangle (props) {
    return React.createElement("svg",props,React.createElement("path",{"stroke":"none","fill":"currentColor","d":"M66.839745962156 18.816043908598a10 10 0 0 1 17.320508075689 0l59.679491924311 103.3679121828a10 10 0 0 1 -8.6602540378444 15l-119.35898384862 0a10 10 0 0 1 -8.6602540378444 -15"}));
}

Triangle.defaultProps = {"width":"151","height":"151","viewBox":"0 0 151 151"};

module.exports = Triangle;

Triangle.default = Triangle;
